<template>
  <div id="model">
    <div>
      <div :style="{'z-index': coverZ ? coverZ : ''}" ref="cover" class="cover"></div>
      <div ref="allModel" class="allModel">
        <div :style="{'width':minWidth === undefined || minWidth === null ?'800px':minWidth}" class="content">
          <div class="modelHead d_flex">
            <span></span>
            <span class="split2_l font20" style="width: auto">{{title === undefined || title === null ? '选择用户': title}}</span>
            <span class="split2_r" style="width: auto"><i @click="cancelModel()" class="icon iconfont iconguanbi1" style="font-weight: 100;font-size: 24px"></i></span>
          </div>
          <!--<div class="modelBody">-->
          <div v-if="showAuto" class="allModelOverFlow">
            <slot>
              没内容
            </slot>
          </div>
          <div v-else class="allModelOverFlow" :style="{'max-height': maxHeight ? maxHeight : '500px'}" style="overflow: auto;">
            <slot>
              没内容
            </slot>
          </div>
          <div v-if="buttonType !== 2" class="modelFoot">
            <div v-if="buttonType === 1">
              <button @click="cancelModel()" class="redButtonTwo m_r_10 m_l_10">确定</button>
            </div>
            <div v-if="buttonType === 0">
              <button @click="confirmModel()" class="redButtonTwo m_r_10 m_l_10">确定</button>
              <button @click="cancelModel()" class="cancelButtonTwo m_l_10 m_r_10">取消</button>
            </div>
            <div v-if="buttonType === 3">
              <button @click="cancelModel()" class="cancelButtonTwo m_r_10 m_l_10">返回</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'model',
  props: [
    'showAuto',
    'coverZ',
    'buttonType',
    'minWidth',
    'maxHeight',
    'title',
    'showModel'
  ],
  data () {
    return {
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    const that = this
    setTimeout(function () {
      that.$refs.cover.style.opacity = 1
      that.$refs.allModel.style.opacity = 1
      that.$refs.allModel.style.top = '0'
    }, 10)
  },
  methods: { // 所有的方法封装
    cancelModel () {
      const that = this
      that.$refs.cover.style.opacity = 0
      that.$refs.allModel.style.opacity = 0
      that.$refs.allModel.style.top = '-100px'
      setTimeout(function () {
        that.$emit('on-cancel', '')
      }, 500)
    },
    confirmModel () {
      this.$emit('on-confirm', '')
    }
  },
  components: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myComponents/model.vue